import React from "react";
import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor";

const counterUpContent = [
  {
    startCount: "0",
    endCount: "66",
    endPointText: " đơn vị",
    meta: "Đã sử dụng eKYC",
    animationDelay: "0",
    bgColor: "#25E5DA",
  },
  {
    startCount: "0",
    endCount: "912",
    endPointText: " triệu",
    meta: "Yêu cầu xác minh",
    animationDelay: "100",
    bgColor: "#FF36AF",
  },
  {
    startCount: "0",
    endCount: "2",
    endPointText: " phút",
    meta: "Thời gian onboarding khách hàng",
    animationDelay: "200",
    bgColor: "#FFB13A",
  },
];

const CounterFour = () => {
  const [focus, setFocus] = React.useState(false);
  return (
    <div className="row justify-content-center">
      {counterUpContent.map((val, i) => (
        <div
          className="col-lg-4 col-sm-6"
          data-aos="fade-up"
          data-aos-duration="1200"
          data-aos-delay={val.animationDelay}
          key={i}
        >
          <div className="counter-box-two">
            <h2 className="number">
              <span className="timer">
                {" "}
                <CountUp
                  start={focus ? val.startCount : null}
                  end={val.endCount}
                  duration={1}
                  redraw={true}
                >
                  {({ countUpRef }) => (
                    <VisibilitySensor
                      onChange={(isVisible) => {
                        if (isVisible) {
                          setFocus(true);
                        }
                      }}
                    >
                      <span ref={countUpRef} />
                    </VisibilitySensor>
                  )}
                </CountUp>
              </span>
              {val.endPointText}
            </h2>
            <p className="font-rubik">{val.meta}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CounterFour;
